module.exports = __webpack_public_path__ + "static/images/components/ProductionProgress/images/cancel-button-hover.def97a1b.png";


//////////////////
// WEBPACK FOOTER
// ./components/ProductionProgress/images/cancel-button-hover.png
// module id = 2660
// module chunks = 11